import { faPersonDress } from "@fortawesome/free-solid-svg-icons";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import GaugeChart from "../components/GaugeChart";
import Percentage from "../components/Percentage";
import CustomWidget from "./CustomWidget";

import { Box } from "@mui/material";
import "./Widget1.css";

const Widget1 = ({ data }) => {
  const { t } = useTranslation();
  if (!data) return null;

  //const pregnantWomen = +data.pregnantWomen?.[0]?.[1] || 0;
  // const gauge1 = [+data.pregnantTeen?.[0]?.[1] || 0, 100];
  //const gauge2 = [+data.ancIFA?.[0]?.[1] || 0, 100];

  // DEMO datas
  const pregnantWomen = 65;
  const gauge1 = [70, 100];
  const gauge2 = [59, 100];

  const getDataGauge = (data) => {
    return {
      label: [""],
      datasets: [
        {
          data: [Math.round(data[0]), Math.round(data[1] - data[0])],
          backgroundColor: ["#31589d", "#eca91d"],
          borderColor: ["#31589d", "#eca91d"],
          circumference: 180,
          rotation: 270,
        },
      ],
    };
  };

  return (
    <div className="top-widget-container">
      <CustomWidget title="" style={{ minWidth: 470 }}>
        <Percentage
          data={pregnantWomen.toFixed(0)}
          unit={"%"}
          icon={faPersonDress}
          numberOfIcon={10}
          text={t("Pregnant women accessed Ante-Natal Care (ANC)")}
          backgroundColor={["#31589d", "#eca91d"]}
        />
      </CustomWidget>
      <CustomWidget title={t("Teenage pregnancies")}>
        <Box sx={{ padding: { xs: "0 5px", md: "0 20px" } }}>
          <GaugeChart data={getDataGauge(gauge1)} fontSize={24} />
        </Box>
      </CustomWidget>
      <CustomWidget title={t("ANC IFA supplementation")}>
        <Box sx={{ padding: { xs: "0 5px", md: "0 20px" } }}>
          <GaugeChart data={getDataGauge(gauge2)} fontSize={24} />
        </Box>
      </CustomWidget>
    </div>
  );
};

export default memo(Widget1);
